import { createFileRoute } from "@tanstack/react-router";
import { OrganizationAdminSettingsPage } from "./-components/organization-admin-settings-page";

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/settings")({
  component: () => {
    const { organizationId } = Route.useParams();

    return <OrganizationAdminSettingsPage organizationId={organizationId} />;
  },
});
